import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import closeModal from 'Helpers/ModalHelper';
import useCollection from 'Hooks/useCollection';
import { makeStyles } from '@material-ui/core';
import useMobile from 'Hooks/useMobileLayout';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { ClientActionItemOverride } from 'Overrides/ActionItem';
import MetaCollectionFormDialog from 'Components/UI/Meta/MetaForm/MetaCollectionFormDialog';

import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';
import { addQueryWithReplace, QueryVal } from '../../../Helpers/Query';

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    width: theme.dimensions.xl,
    maxWidth: theme.dimensions.xl,
  },
}));

function GoalActionItemModal({ actionItemId }) {
  const { collection, setCollection } = useCollection();
  const { collection: goalCollection, setCollection: setGoalCollection } = useCollection();
  const { householdResource, getHousehold } = useSimpleHousehold();
  const isMobile = useMobile();
  const classes = useStyles();

  const goalId = QueryVal('goalId');

  const handleClose = () => {
    addQueryWithReplace({ refresh: 'goalActionItem' });
    closeModal();
  };

  const getGoal = async () => {
    try {
      if (!householdResource) {
        await getHousehold();
      }

      const goal = await householdResource?.relationship('goals')?.link('related').Get({
        params: {
          id: goalId,
        },
      });

      setGoalCollection(goal);
    } catch (e) {
      displayErrorMessage(e, 'Could not fetch goal');
    }
  };

  const getActionItems = async () => {
    if (goalCollection?.resources().head().relationship('actionItems')?.link('related')) {
      const goal = goalCollection.resources().head();
      const actionItems = await goal
        .relationship('actionItems')
        .link('related')
        .Get({
          metaOverrideSet: ClientActionItemOverride,
          params: actionItemId ? { id: actionItemId } : { limit: 0, offset: 0 },
        });


      if (actionItems.resources().length() === 0) {
        actionItems.create({
          metaOverrideSet: ClientActionItemOverride,
          addToCollection: true,
        });
      }
      setCollection(actionItems);
    }
  };

  useEffect(() => {
    getGoal();
  }, [goalId]);

  useEffect(() => {
    getActionItems();
  }, [goalCollection]);

  const onSuccess = () => {
    displaySuccess('To do saved');
    handleClose();
  };

  const onFailure = (err) => {
    displayErrorMessage(err, err.errors);
  };

  if (!collection) return null;

  const mobileLayout = [['name'], ['dueDate'], ['priority']];
  const desktopLayout = [['name'], ['dueDate', 'priority']];

  return (
    <MetaCollectionFormDialog
      classes={{
        dialogPaper: classes.dialogPaper,
      }}
      collection={collection}
      onClose={handleClose}
      onFailure={onFailure}
      onSubmit={onSuccess}
      rows={isMobile ? mobileLayout : desktopLayout}
      title={actionItemId ? 'Edit Action Item' : 'Add Action Item'}
    />
  );
}

GoalActionItemModal.defaultProps = {
  actionItemId: null,
};

GoalActionItemModal.propTypes = {
  actionItemId: PropTypes.string,
};

export default GoalActionItemModal;
